module.exports = __webpack_public_path__ + "img/v4_main1.a0013f91.png";